import {Component, Inject, OnInit,   ViewChild, ElementRef } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EndoDiagnosisDataModel} from '../../models/endo-diagnosis-data.model';
import {TdoEnumSelectComponent} from "../../../../../../tdo-controls/common/tdo-enum-select/tdo-enum-select.component";

@Component({
  standalone: false,
  selector: 'app-diagnosis-soft-tissue-dialog',
  templateUrl: './diagnosis-soft-tissue-dialog.component.html',
  styleUrls: ['./diagnosis-soft-tissue-dialog.component.scss']
})
export class DiagnosisSoftTissueDialogComponent implements OnInit {

  @ViewChild("idenumDiagSTEFace") idenumDiagSTEFace: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTENeck") idenumDiagSTENeck: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTELips") idenumDiagSTELips: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTETongue") idenumDiagSTETongue: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEFloorOfMouth") idenumDiagSTEFloorOfMouth: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEAlveolarMucosa") idenumDiagSTEAlveolarMucosa: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEHardPlate") idenumDiagSTEHardPlate: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTESoftPlate") idenumDiagSTESoftPlate: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEGingiva") idenumDiagSTEGingiva: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTELingAttachGingiva") idenumDiagSTELingAttachGingiva: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEBuccalAttachGingiva") idenumDiagSTEBuccalAttachGingiva: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEOropharynx") idenumDiagSTEOropharynx: TdoEnumSelectComponent;





  isChangeMade: boolean = false;

  constructor(private dialogRef: MatDialogRef<DiagnosisSoftTissueDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: EndoDiagnosisDataModel) { }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.isChangeMade);
  }

  setSoftTissueDefault() {

    try {
      this.data.cest_STE_enumDiagSTEFaceID = this.getWnlValueItemId(this.idenumDiagSTEFace);
      this.data.cest_STE_enumDiagSTENeckID = this.getWnlValueItemId(this.idenumDiagSTENeck);
      this.data.cest_STE_enumDiagSTELipsID = this.getWnlValueItemId(this.idenumDiagSTELips);
      this.data.cest_STE_enumDiagSTETongueID = this.getWnlValueItemId(this.idenumDiagSTETongue);
      this.data.cest_STE_enumDiagSTEFloorOfMouthID = this.getWnlValueItemId(this.idenumDiagSTEFloorOfMouth);
      this.data.cest_STE_enumDiagSTEAlveolarMucosaID = this.getWnlValueItemId(this.idenumDiagSTEAlveolarMucosa);
      this.data.cest_STE_enumDiagSTEHardPlateID = this.getWnlValueItemId(this.idenumDiagSTEHardPlate);
      this.data.cest_STE_enumDiagSTESoftPlateID = this.getWnlValueItemId(this.idenumDiagSTESoftPlate);
      this.data.cest_STE_enumDiagSTEGingivaID = this.getWnlValueItemId(this.idenumDiagSTEGingiva);
      this.data.cest_STE_enumDiagSTELingAttachGingivaID = this.getWnlValueItemId(this.idenumDiagSTELingAttachGingiva);
      this.data.cest_STE_enumDiagSTEBuccalAttachGingivaID = this.getWnlValueItemId(this.idenumDiagSTEBuccalAttachGingiva);
      this.data.cest_STE_enumDiagSTEOropharynxID = this.getWnlValueItemId(this.idenumDiagSTEOropharynx);
      this.isChangeMade = true;


    }
    catch (e)
    {
      console.error('setSoftTissueDefault error: ', e);
    }
  }

  /**
   * Returns the ValidValueItemId of the item whose display value is "WNL"
   * (Within Normal Limits). Falls back to the first item when no WNL item exists.
   */
  private getWnlValueItemId(enumSelect?: TdoEnumSelectComponent): string {
    const items = enumSelect?.validValueItems ?? [];
    if (items.length === 0) return '';

    const wnlItem = items.find(item => item.ItemDisplayValue?.trim().toUpperCase() === 'WNL');
    return (wnlItem ?? items[0]).ValidValueItemId;
  }
}
